import React, { useEffect, useState } from "react";
import {
  convertUTCtoLocalDate,
  convertUTCtoLocalTime,
} from "../../utils/CommonUtils";
import { Button, CircularProgress } from "@mui/material";
import PDFButton from "../../components/Common/pdfButton/pdfButton";
import { getDashboardData } from "../../services/DashboardServices";
import { useNavigate } from "react-router-dom";
import viewIcon from "../../assets/Icons/view.svg";
import dropdown from '../../assets/Icons/dropdown.svg';
import searchIcon from '../../assets/Icons/search-line.svg';
import { useOrgContext } from "../../Context/orgContext";

const ListOfAllReport = ({ clinicId }) => {
  const [page, setPage] = useState(0);
  const [pageMetaData, setPageMetaData] = useState({}); //{page: 0, total_pages: 0, total_records: 0, per_page: 0}
  const [dashboardData, setDashboardData] = useState([]);
  const [search, setSearch] = useState(null); //search by username, email id
  const [filter, setFilter] = useState(null); //filter by status
  const [sort, setSort] = useState(null); //sort by latest first
  const navigate = useNavigate();
  const { orgDetails } = useOrgContext();
  const [ prevClinicId , setPreviousClinicId ] = useState(null);
  const [ reportsLoading , setReportsLoading ] = useState(false);
  const [ prevSearch , setPrevSearch ] = useState('');
  const [ searchInput , setSearchInput ] = useState("");

  useEffect(() => {
    if( prevClinicId === clinicId ){
      setReportsLoading(true);
      getDashboardData({page, sort,filter,searchParam:search, selectedClinicCode: clinicId}).then((res) => {
        if( search === prevSearch ){
          setDashboardData(prev => [ ...prev , ...res.data.user_report_details_list]);
        }else{
          setDashboardData(res.data.user_report_details_list);
        }
        setPageMetaData(res.data);
        setPreviousClinicId(clinicId);
        setReportsLoading(false);
        setPrevSearch(search);
      });
    }else{
      setPage(0);
      setReportsLoading(true);
      getDashboardData({ page: 0, sort,filter,searchParam:search, selectedClinicCode: clinicId }).then((res) => {
        setDashboardData(res.data.user_report_details_list);
        setPageMetaData(res.data);
        setPreviousClinicId(clinicId);
        setReportsLoading(false);
      });
    }
  }, [ page, search, filter, sort, clinicId ]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setPage(0);
      setSearch(searchInput);
    }, 500);

    return () => clearTimeout(timer);
  } , [ searchInput ]);
  
  return (
    <div>
      <div className="mb-5">
        <input
          type="search"
          placeholder="Search by Username, Email Id..."
          name=""
          id=""
          className="w-full outline-none px-10 py-3 rounded-[10px]"
          style={{
            border: "1px solid #EAECF0",
            backgroundImage: `url(${searchIcon})`,
            paddingLeft: "50px",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "10px center",
          }}
          onChange={(e) => {
            setSearchInput(e.target.value);
          }}
        />
      </div>
      <div className="bg-[#fff] px-6 py-5 flex items-center justify-between">
        <div>
          All Reports{" "}
          <span className="text-[#5A6AF6] text-xs font-medium px-2 py-1 bg-[#F9F5FF] rounded-2xl">
            {pageMetaData && pageMetaData.total_reports_count} Reports
          </span>
        </div>
        <div className="flex gap-3">
          <select
            name=""
            id=""
            className="outline-none rounded appearance-none  px-3 py-2"
            style={{
              border: "1px solid #E1E5EB",
              backgroundImage: `url(${dropdown})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right 10px center",
              backgroundSize: "20px",
              paddingRight: "30px",
            }}
            onChange={(e) => {
              setFilter(e.target.value);
            }}
          >
            <option value="">All</option>
            <option
              value="viewed"
            >
              Viewed
            </option>
            <option value="edited">Edited</option>
            <option value="new">New</option>
          </select>
          <select
            name=""
            id=""
            className="outline-none rounded appearance-none  px-3 py-2"
            style={{
              border: "1px solid #E1E5EB",
              backgroundImage: `url(${dropdown})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right 10px center",
              backgroundSize: "20px",
              paddingRight: "30px",
            }}
            onChange={(e) => {
              setSort(e.target.value);
            }}
          >
            <option value="timeDsc">Sort By: Latest First</option>
            <option value="timeAsc">Sort By: Oldest First</option>
          </select>
        </div>
      </div>
      <div>
        <div className="flex items-center justify-between bg-[#415280] text-[#fff]">
          <div className="w-[80px] h-11 pl-6 py-3">Sr.no</div>
          <div className="w-[204px] pl-6 py-3">Assessment Date & Time</div>
          <div className="w-[400px] h-11 pl-6 py-3">Session Id</div>
          <div className="w-[232px] h-11 pl-6 py-3">Status</div>
          <div className="w-[202px] h-11 pl-6 py-3">Action</div>
          <div className="w-[138px] h-11 pl-6 py-3">PDF Report</div>
        </div>
        <div className="bg-[#fff]">
          { 
            reportsLoading
            ? <div className="py-[2rem] flex justify-center items-center"><CircularProgress /></div>
            : dashboardData.map((item, index) => (
                <div className="flex items-center justify-between py-3 border-b border-solid ">
                  <div className="w-[80px] h-11 pl-6">{item.serial_number}</div>
                  <div className="w-[204px] h-11 pl-6">
                    <div className="text-[#101828] text-sm leading-5 font-medium">
                      {convertUTCtoLocalDate(
                        item.assessment_date,
                        item.assessment_time
                      )}
                    </div>
                    <div className="text-[#475467] font-normal text-sm leading-5">
                      at &nbsp;
                      {convertUTCtoLocalTime(
                        item.assessment_date,
                        item.assessment_time
                      )}
                    </div>
                  </div>
                  <div className="w-[400px] text-[#475467] text-sm leading-5 font-normal pl-6 h-auto">
                    {item.client_session_id}
                  </div> 
                  <div className="w-[232px] h-11 pl-6">
                  {
                        orgDetails.organisation_code === "simpletx" &&
                        (item.status === "Approved" ? (
                          <div className="bg-[#E0FFD9] text-xs leading-[18px] font-medium text-[#229606] w-fit px-3 py-2 cursor-pointer text-center rounded-2xl flex items-center justify-center">
                            {item.status}
                          </div>
                        ) 
                        : (
                          <div className="text-[#175CD3] text-xs leading-[18px] font-medium bg-[#EFF8FF] w-fit px-3 py-2 cursor-pointer text-center rounded-2xl flex items-center justify-center">
                            Not Approved
                          </div>
                        ))
                      }
                      {
                        orgDetails.organisation_code !== "simpletx" &&
                        (item.status === "New" ? (
                          <div className="bg-[#E0FFD9] text-xs leading-[18px] font-medium text-[#229606] w-[60px] h-[22px] text-center rounded-2xl flex items-center justify-center">
                            {item.status}
                          </div>
                        ) : item.status === "Viewed" ? (
                          <div className="flex gap-1">
                            <div className="text-[#175CD3] text-xs leading-[18px] font-medium bg-[#EFF8FF] w-[60px] h-[22px] text-center rounded-2xl flex items-center justify-center">
                              {item.status}
                            </div>
                            <div className="text-[#475467] font-normal text-sm leading-5">
                              on &nbsp;
                              {convertUTCtoLocalDate(
                                item.report_last_viewed_at,
                                item.report_last_viewed_time
                              )}
                            </div>
                          </div>
                        ) : null)
                      }
                  </div>
                  <div className="flex gap-1 w-[202px] h-11 pl-6">
                    <Button
                      sx={{
                        backgroundColor: "#788CFC",
                        color: "#fff",
                        width: "76px",
                        height: "28px",
                        "&:hover": {
                          backgroundColor: "#788CFC",
                          color: "#fff",
                        },
                      }}
                      onClick={() => {
                        navigate(
                          `/view-report/${item.end_user_id}/${item.encrypted_session_id}`
                        );
                      }}
                    >
                      <img src={viewIcon} alt="" />
                      <div className="text-xs leading-[18px] font-medium pl-1">
                        View
                      </div>
                    </Button>
                  </div>
                  <div className="w-[138px] h-11 pl-6">
                    <PDFButton data={item} />
                  </div>
                </div>
              ))
          }
        </div>
        <div className="flex justify-center">
          {pageMetaData && !pageMetaData.last_page && (
            <div
              className="bg-[#E1E1E1] rounded-[5px] mt-[70px] w-[190px] px-8 py-3 text-[#000000] font-medium text-sm leading-5 mb-[84px] cursor-pointer"
              onClick={() => {
                setPage((prev) => prev + 1);
              }}
            >
              {" "}
              Load More Reports
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListOfAllReport;